import React, {Component} from 'react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faCircle} from '@fortawesome/pro-light-svg-icons/faCircle';

const Wrapper = styled.div`
    opacity: ${props => props.isDisabled ? 0.5 : 1 };
    transition: opacity 250ms ease-in-out;
`;

class FilterOption extends Component {
    toggle = () => {
        const {onChanged, filterItem, isChecked, isDisabled} = this.props;
        if (isChecked || !isDisabled) {
            const id = filterItem.Id || filterItem.ValueId;
            onChanged(id)
        }
    };
    
    render() {
        const {filterItem, isChecked, isDisabled} = this.props;
        
        return <Wrapper className={`py-1 line-height-3 d-flex justify-content-between cursor-pointer ${isChecked ? 'text-primary text-hover-blue-medium' : 'text-gray text-hover-primary'}`} onClick={this.toggle} isDisabled={isDisabled}>
            <div className="font-size-0-75">
                {filterItem.Name}
            </div>
            <div className="mx-2 flex-shrink-0">
                {
                    isChecked ?
                        <FontAwesomeIcon icon={faCheckCircle} /> :
                        <FontAwesomeIcon icon={faCircle} />
                }
            </div>
        </Wrapper>
    }
}

export default FilterOption;
